import { api } from '@src/constants/api';
import { createMiddleware, Next, regularErrorHandling } from '@src/utils';
import { userActions, userErrorMessage } from '@src/store/reducers/userReducer';
import { securityActions } from '@src/store/reducers/securityReducer';

export const createUsersMiddleware = (http: any, successPopUp: any, errorPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    const wrapperNext = (next: Next, action: any, data: any) => {
        data.typeAction = action.type;
        data.requestParam = action.payload;
        next(data);
    };
    const transformResponse = (action: any) => (data: any, header: any) => {
        return window['cTransformResponse'](data, header, action);
    };
    return createMiddleware({
        [userActions.RESET_TRYING]: async ({ payload }: any, next: Next) => {
            try {
                const params = { username: payload.username, password: payload.newPassword };
                const response = await http.put(`${restServiceUrl}users/2`, params);
                if (response.data) {
                    next({ type: userActions.RESET_SUCCESS, payload: { message: userErrorMessage.RESET_SUCCESS, pending: false } });
                    next({ type: securityActions.LOGOUT });
                } else {
                    next({ type: userActions.RESET_FAILURE, payload: { message: userErrorMessage.RESET_FAILURE, pending: false } });
                }
            } catch {
                next({ type: userActions.RESET_FAILURE, payload: { message: userErrorMessage.RESET_FAILURE, pending: false } });
            }
        },
        [userActions.GET_MODULES]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Users/GetUserModules`);
            next({ type: userActions.SET_MODULES, payload: { userModules: response.data } });
        },
        [userActions.GET_USER]: async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Users/${action.payload.userId}`);
            next({ type: action.type, payload: response.data });
        },
        [userActions.GET_USERS]: async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Users`);
            next({ type: action.type, payload: response.data });
        },
        [userActions.ADD_USER]: async (action: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}Users/CreateNewUser`, action.payload.userData);
                const data = response.data;
                if (data) {
                    successPopUp();
                    wrapperNext(next, action, { type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
                errorPopUp();
            }
        },
        [userActions.DUPLICATE_USER]: async (action: any, next: Next) => {
            next({ type: action.type, payload: action.payload.userId });
        },
        [userActions.GET_USER_GROUPS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}UserGroups`);
                const data = response.data;
                next({ type: action.type, payload: data });
            } catch {
            }
        },
        [userActions.ADD_USER_GROUPS]: async (action: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}UserGroups/CreateNewGroup`, action.payload.groupData);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
                errorPopUp();
            }
        },
        [userActions.GET_ROLES]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Roles`);
                const data = response.data;
                next({ type: action.type, payload: data });
            } catch {
            }
        },
        [userActions.GET_ROLE]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Roles/${action.payload.roleId}`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.GET_PERMISSIONS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Permissions`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.GET_GROUP]: async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}UserGroups/${action.payload.groupId}`);
            next({ type: action.type, payload: response.data });
        },
        [userActions.GET_ALL_USERS_AND_GROUPS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}UserGroupsAndUsers`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.GET_USERS_AND_GROUPS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}UserGroupsAndUsers/${action.payload.projectId}`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.GET_USERS_AND_GROUPS_FOR_PROJCET_GROUP]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}UserGroupsAndUsersByProjectGroup/${action.payload.projectId}`;
                const response = await http.get(url);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.SAVE_USERS_AND_GROUPS]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}GroupsAndUsers/${action.payload.projectId}`;
                const response = await http.post(url, action.payload.data);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
                errorPopUp();
            }
        },
        [userActions.SAVE_USER]: async (action: any, next: Next, state: any) => {
            try {
                const url = `${restServiceUrl}Users/${action.payload.userId}`;
                const response = await http.put(url, action.payload.userData);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: action.type, payload: response.data });
                    state.dispatch({ type: userActions.GET_USER, payload: { userId: action.payload.userId } });
                } else {
                    errorPopUp();
                }
            } catch (error) {
                errorPopUp(error);
            }
        },
        [userActions.SAVE_GROUP]: async (action: any, next: Next, state: any) => {
            try {
                const url = `${restServiceUrl}UserGroups/${action.payload.groupId}`;
                const response = await http.put(url, action.payload.groupData);
                const  data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: action.type, payload: response.data });
                    state.dispatch({ type: userActions.GET_USER_GROUPS, payload: { groupId: action.payload.groupId } });
                } else {
                    errorPopUp();
                }
            } catch (error) {
                errorPopUp(error);
            }
        },
        [userActions.SAVE_ROLE]: async (action: any, next: Next, state: any) => {
            const response = await http.put(`${restServiceUrl}Roles`, action.payload.roleData);
            if (response && response.data) {
                successPopUp();
                next({ type: action.type, payload: response.data });
                state.dispatch({ type: userActions.GET_ROLE, payload: { roleId: action.payload.roleId } });
            } else {
                errorPopUp();
            }
        },
        [userActions.ADD_ROLE]: async (action: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}Roles/CreateNewRole`, action.payload.roleData);
                if (response && response.data) {
                    successPopUp();
                    next({ type: action.type, payload: response.data });
                }
            }
            catch {
            }
        },
        [userActions.GET_USER_ROLES]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}Users/${action.payload.userId}/ProjectRoles/${action.payload.projectId}`;
                const response = await http.get(url);
                const data = response.data;
                next({ userId : action.payload.userId, type: action.type, payload: data });
                return data;
            } catch {
            }
        },
        [userActions.GET_USER_GROUP_ROLES]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}UserGroups/${action.payload.userGroupId}/ProjectRoles/${action.payload.projectId}`;
                const response = await http.get(url);
                const data = response.data;
                next({ userGroupId : action.payload.userGroupId, type: action.type, payload: data });
                return data;
            } catch {
            }
        },
        [userActions.GET_PROJECT_GROUP_ROLES]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}Users/${action.payload.userId}/ProjectGroupRoles/${action.payload.projectId}`;
                const response = await http.get(url);
                const data = response.data;
                next({ userId: action.payload.userId, type: action.type, payload: data });
                return data;
            } catch {
            }
        },
        [userActions.GET_PROJECT_GROUP_ROLES_BY_USER_GROUP]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}UserGroups/${action.payload.userGroupId}/ProjectGroupRoles/${action.payload.projectId}`;
                const response = await http.get(url);
                const data = response.data;
                next({ userGroupId:action.payload.userGroupId, type: action.type, payload: data });
                return data;
            } catch {
            }
        },
        [userActions.SAVE_USER_ROLES]: async (action: any) => {
            try {
                const response = await http({
                    method: 'POST',
                    url: `${restServiceUrl}Users/${action.payload.userId}/ProjectRoles/${action.payload.projectId}`,
                    data: action.payload.rolesData,
                    SilentRequest: action.silentRequest,
                    transformResponse: transformResponse(action)
                });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [userActions.SAVE_USER_GROUP_ROLES]: async (action: any) => {
            try {
                const response = await http({
                    method: 'POST',
                    url: `${restServiceUrl}UserGroups/${action.payload.userGroupId}/UserGroupAndProjectRoles/${action.payload.projectId}`,
                    data: action.payload.rolesData,
                    SilentRequest: action.silentRequest,
                    transformResponse: transformResponse(action)
                });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [userActions.SAVE_PROJECT_GROUP_ROLES_BY_USER]: async (action: any) => {
            try {
                const response = await http({
                    method: 'POST',
                    url: `${restServiceUrl}Users/${action.payload.userId}/ProjectGroupRoles/${action.payload.projectId}`,
                    data: action.payload.rolesData,
                    SilentRequest: action.silentRequest,
                    transformResponse: transformResponse(action)
                });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [userActions.SAVE_PROJECT_GROUP_ROLES_BY_USER_GROUP]: async (action: any) => {
            try {
                const response = await http({
                    method: 'POST',
                    url: `${restServiceUrl}UserGroups/${action.payload.userGroupId}/ProjectGroupRoles/${action.payload.projectId}`,
                    data: action.payload.rolesData,
                    SilentRequest: action.silentRequest,
                    transformResponse: transformResponse(action)
                });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [userActions.GET_DOMAIN]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}DomainManager/${action.payload.domainId}`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.GET_DOMAINS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}DomainManager`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.ADD_DOMAIN]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}DomainManager/CreateNewDomain`;
                const response = await http.post(url, action.payload.domainData);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
            }
        },
        [userActions.SAVE_DOMAIN]: async (action: any, next: Next) => {
            try {
                delete action.payload.domainData.id;
                const url = `${restServiceUrl}DomainManager/${action.payload.domainId}`;
                const response = await http.put(url, action.payload.domainData);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
            }
        },
        [userActions.TEST_DOMAIN_CONFIGURATION]: async (action: any) => {
            try {
                const url = `${restServiceUrl}TestDomain`;
                const response = await http.post(url, action.payload.domainData);
                return response.data;
            } catch {
                errorPopUp();
            }
        },
        [userActions.SYNC_ALL_USERS_PERMISSIONS]: async (action: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}SyncAllUsers/${action.payload.domainId}`);
                const data = response.data;
                if (data) {
                    const messageObj = { message: 'Sync Started Successfully', text: '' };
                    successPopUp(messageObj);
                    next({ type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
            }
        },
        
        [userActions.IS_SYNC_ENABLED]:async () => {
            const response = await http.get(`${restServiceUrl}IsSyncEnabled`);
            return response.data;
        },
        [userActions.ASYNC_STATUS]:async (action: any) => {
            
            const response = await http.get(`${restServiceUrl}GetDomainSyncStatus/${action.payload.domainId}`);
            return response.data
          
        },
        [userActions.SYNC_USER_INFO]: async (action: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}SyncUserInfo/${action.payload.userId}`);
                const data = response.data;
                if (data) {
                    const messageObj = { message: 'Sync Started Successfully', text: '' };
                    successPopUp(messageObj);
                    next({ type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
            }
        },
        [userActions.DELETE_DOMAIN]: async (action: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}DomainManager/${action.payload.domainId}`);
                const data = response.data;
                if (data) {
                    next({ type: userActions.REFRESH_DELETE_DOMAIN, payload: action.payload.domainId });
                }
            } catch {
            }
        },
        [userActions.GET_PROJECT_AND_GROUPS]: async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}ProjectAndProjGroups`);
            next({ type: action.type, payload: response.data });
        },
        [userActions.GET_PROJECT_GROUPS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}ProjectGroups`);
                next({ type: action.type, payload: response.data });
                return response.data;
            } catch {
            }
        },
        [userActions.GET_PROJECT_GROUP]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}ProjectGroups/${action.payload.projectGroupId}`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.GET_USER_PROJECT_GROUPS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}UserProjectGroups`);
                next({ type: action.type, payload: response.data });
                return response;
            } catch {
            }
        },
        [userActions.SAVE_PROJECT_GROUP]: async (action: any, next: Next, state: any) => {
            const url = `${restServiceUrl}ProjectGroups/${action.payload.projectGroupId}`;
            const response = await http.put(url, action.payload.projectGroup);
            const data = response.data;
            if (data) {
                successPopUp();
                next({ type: action.type, payload: data });
                state.dispatch({ type: userActions.GET_PROJECT_GROUP, payload: { projectGroupId: action.payload.projectGroupId } });
            } else {
                errorPopUp();
            }
        },
        [userActions.ADD_PROJECT_GROUP]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}ProjectGroups/CreateNewProjectGroup`;
                const response = await http.post(url, action.payload.projectGroup);
                const data = response.data;
                if (data) {
                    successPopUp();
                    next({ type: action.type, payload: data });
                } else {
                    errorPopUp();
                }
            } catch {
            }
        },
        [userActions.DELETE_USER]: async (action: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}Users/${action.payload.userId}`);
                const data = response.data;
                if (data) {
                    next({ type: userActions.REFRESH_DELETE_USER, payload: action.payload.userId });
                }
            } catch {
            }
        },
        [userActions.SET_USER_STATUS]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}Users/${action.payload.userId}/status`;
                const response = await http.put(url, action.payload.status);
                const data = response.data;
                if (data) {
                    next({ type: action.type, payload: action.payload.status });
                }
            } catch {
            }
        },
        [userActions.RESET_PASSWORD]: async (action: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}Users/${action.payload.userId}/Password`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.DUPLICATE_GROUP]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Groups/${action.payload.groupId}/Duplicate`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.DELETE_GROUP]: async ({ payload }: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}UserGroups/${payload.groupId}`);
                if (response.data) {
                    next({ type: userActions.REFRESH_DELETE_USER_GROUP, payload: payload.groupId });
                }
            } catch {
            }
        },
        [userActions.DUPLICATE_ROLE]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Roles/${action.payload.roleId}/Duplicate`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.DELETE_ROLE]: async ({ payload }: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}Roles/${payload.roleId}`);
                if (response.data) {
                    next({ type: userActions.REFRESH_DELETE_ROLE, payload: payload.roleId });
                }
            } catch {
            }
        },
        [userActions.DELETE_PROJECT_GROUP]: async (action: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}ProjectGroups/${action.payload.projectGroupId}`);
                const data = response.data;
                next({ type: action.type, payload: data });
                if (data) {
                    next({ type: userActions.REFRESH_DELETE_PROJECT_GROUPS, payload: action.payload.projectGroupId });
                }
            } catch {
            }
        },
        [userActions.GET_AUTH_TYPE]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}DomainManager/AuthenticationTypes`);
                next({ type: action.type, payload: response.data });
            } catch {
            }
        },
        [userActions.GET_CURRENT_USER_DETAILS]: async () => {
            const response = await http.get(`${restServiceUrl}Users/Current/Details`);
            return response;
        },
        [userActions.GET_USAGE_INFO]: async () => {
            const response = await http.get(`${restServiceUrl}UsedInfo`);
            return response;
        },
        [userActions.GET_PERMISSIONS_FOR_USER]: async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Users/${action.payload.userId}/RolesList`);
            const data = response.data;
            next({ type: action.type, payload: data });
            return data;
        },
        [userActions.USER_CAN_LINK_CMS_TO_PROJECT]: async (action: any, next: Next) => {
            const response = await http({
                method: 'GET',
                url: `${restServiceUrl}Cms/IsAuthorized/${action.payload.userId}/Project/${action.payload.projectId}`,
                SilentRequest: action.silentRequest,
                transformResponse: transformResponse(action)
            });
            const data = response.data;
            next({ type: action.type, payload: data });
            return data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/users.middleware.ts